import request from './index'
import type { LoginData, RegisterData, TokenResponse, User } from '@/types/models'

// 註冊回應
interface RegisterResponse {
  id: string
  email: string
  name: string
  message: string
}

export const authApi = {
  // 登入
  login(data: LoginData) {
    return request.post<TokenResponse>('/auth/login', data)
  },

  // 註冊
  register(data: RegisterData) {
    return request.post<RegisterResponse>('/auth/register', data)
  },

  // 刷新 Token
  refresh(refreshToken: string) {
    return request.post<TokenResponse>('/auth/refresh', {
      refresh_token: refreshToken,
    })
  },

  // 登出
  logout() {
    return request.post('/auth/logout')
  },

  // 取得當前使用者
  me() {
    return request.get<User>('/auth/me')
  },

  // 忘記密碼
  forgotPassword(email: string) {
    return request.post('/auth/forgot-password', { email })
  },

  // 重設密碼
  resetPassword(token: string, newPassword: string) {
    return request.post('/auth/reset-password', { token, new_password: newPassword })
  },

  // 變更密碼
  changePassword(currentPassword: string, newPassword: string) {
    return request.post('/auth/change-password', {
      current_password: currentPassword,
      new_password: newPassword,
    })
  },
}
